export const scrollbarStyles = {
  marginRight: '-16px',
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#E4E4E7',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#D4D4D8',
  },
  '--scrollbar-width': 'thin',
  '--scrollbar-color': '#E4E4E7 transparent',
} as const;
